import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AiMessageIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AiMessage",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.43 10c4.42 0 8-3.58 8-8 0 4.42 3.58 8 8 8-4.42 0-8 3.58-8 8 0-4.42-3.58-8-8-8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.43 19.14c-.63 0-1.14-.51-1.14-1.14 0-3.78-3.08-6.86-6.86-6.86a1.14 1.14 0 1 1 0-2.28c3.78 0 6.86-3.08 6.86-6.86a1.14 1.14 0 1 1 2.28 0c0 3.78 3.08 6.86 6.86 6.86a1.14 1.14 0 1 1 0 2.28c-3.78 0-6.86 3.08-6.86 6.86 0 .63-.51 1.14-1.14 1.14M17.85 10c1.5.83 2.74 2.08 3.58 3.58.83-1.5 2.08-2.74 3.58-3.58a9.26 9.26 0 0 1-3.58-3.58A9.26 9.26 0 0 1 17.85 10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 30.57c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V6.57c0-1.89 1.54-3.43 3.43-3.43h11.43a1.14 1.14 0 1 1 0 2.28H4.29c-.63 0-1.14.51-1.14 1.14v20.1l4.91-4.91c.21-.21.5-.33.81-.33h16c.63 0 1.14-.51 1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 1.89-1.54 3.43-3.43 3.43H9.33l-6.52 6.52c-.22.22-.51.33-.81.33Z"
    })]
  }));
};